module.exports = __webpack_public_path__ + "fonts/Inter-roman.var.90e8f61.woff2";